import { useEffect, useState } from "react";
import { feature } from "topojson-client";
import { log } from "../../lib/log";
import { W, H, PATH_GEN, CAPITALS } from "./constants";

let topoPromise = null;
let projectedCache = null;

// Kick off the 750KB TopoJSON download early (e.g. when the Scanner page mounts) so the map is
// instant once the scan result arrives.
export function prefetchWorldPaths() {
  if (!topoPromise) topoPromise = fetch("/countries-50m.json").then((r) => r.json());
  return topoPromise;
}

// Loads Natural-Earth TopoJSON once and projects every country into an SVG path + centroid + area.
export function useWorldPaths() {
  const [worldPaths, setWorldPaths] = useState(projectedCache || []);
  useEffect(() => {
    if (projectedCache) return;
    let alive = true;
    prefetchWorldPaths()
      .then((topo) => {
        if (!alive) return;
        const fc = feature(topo, topo.objects.countries);
        const paths = fc.features.map((c) => {
          const d = PATH_GEN(c);
          if (!d) return null;
          const [cX, cY] = PATH_GEN.centroid(c);
          const area = PATH_GEN.area(c) || 0;
          return {
            d,
            name: c.properties?.name || "",
            capital: CAPITALS[c.properties?.name] || null,
            cx: Number.isFinite(cX) ? cX : 0,
            cy: Number.isFinite(cY) ? cY : 0,
            area: area / (W * H),
          };
        }).filter(Boolean);
        projectedCache = paths;
        setWorldPaths(paths);
      })
      .catch((e) => log.warn("WorldMap: countries TopoJSON load failed:", e));
    return () => { alive = false; };
  }, []);
  return worldPaths;
}
